<template>
    <div style="border-bottom: 1px solid #ededed; padding-bottom: 40px;" :style="{ paddingTop: isFirst ? '' : '40px' }">
        <div style="text-align: center; margin-bottom: 16px;">{{ title }}</div>
        <div style="height:16px; background-color: #f5f5f5; border-radius:8px;width:100%;position:relative; overflow:hidden;">
            <div :style="{ width: saveGood >= saveBad ? saveGood + '%' : saveBad + '%', backgroundColor: backGroundAndTextColor, left: saveGood >= saveBad ? '0' : '', right: saveBad > saveGood ? '0' : '' }" style="position:absolute; height: 100%; border-radius:8px; transition: all 2.5s;"></div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 10px;">
            <div style="font-weight: 400; font-size: 14px;">{{ good }}%</div>
            <div style="font-weight: 400; font-size: 14px;">{{ bad }}%</div>
        </div>
        <div style="display: flex; justify-content: space-between; margin-top: 6px;">
            <div :style="{ color: good >= bad ? backGroundAndTextColor : '#101014' }" style="font-size: 14px;">좋음</div>
            <div :style="{ color: bad > good ? backGroundAndTextColor : '#101014' }" style="font-size: 14px;">안좋음</div>
        </div>
        <div style="background-color: #f5f5f5; border-radius: 12px; padding: 20px; margin-top: 20px;">
            <div v-html="feedBackContents" style="font-weight: 500; font-size: 12px; line-height: 20px;"></div>
        </div>
        <div @click="showFeedBack" :style="{ color: isPro ? 'var(--color-main)' : '#d9d9d9' }" style="color: var(--color-main); font-weight: 500; font-size: 14px; margin-top: 12px; text-align: right;">피드백 보기</div>
    </div>
</template>

<script>
export default {
    name: 'AbilityAnalysis',
    props: {
        title: {
            type: String,
            default: ''
        },
        showFeedBack: {
            type: Function,
            default: () => { }
        },
        backGroundAndTextColor: {
            type: String,
            default: ''
        },
        good: {
            type: Number,
            default: 0
        },
        bad: {
            type: Number,
            default: 0
        },
        feedBackContents: {
            type: String,
            default: ''
        },
        isPro: {
            type: Boolean,
            default: true
        },
        isCloseElement: {
            type: Boolean,
            default: false,
        },
        isFirst: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            saveGood: 0,
            saveBad: 0,
            saveNo: 0,
        }
    },
    watch: {
        isCloseElement() {
            this.saveGood = this.good
            this.saveBad = this.bad
        }
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}
</style>